export const resetPasswordConfig = {
  resetPasswordEP: '/password/reset',
  resetMessage: 'Password Reset Successful',
};
